/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import * as utils from 'utils';
import * as moment from 'moment';
// import firebase from 'firebase/compat/app';
import * as bowser from 'bowser';
import { default as Point } from '@appLegacy/lib/math/Point';
import { ENV_CONFIG } from 'src/app/app-data/constants/dynamic-env';

export function windowifier() {
	window.utils = utils;
	window.Point = Point;
	window.moment = moment;
	// window.firebase = firebase;
	window.bowser = bowser;
	window.gitHash = ENV_CONFIG.shortSha;
}
